module.exports = __webpack_public_path__ + "img/FOPTimeSeries.ae1f5112.png";